import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

export const meta = {
  slug: "simple-bookkeeping-1099",
  title: "Simple Bookkeeping for 1099 Contractors",
  description: "A lightweight bookkeeping workflow for freelancers and small businesses—track income, expenses, and receipts without the overwhelm.",
  date: "2025-01-08",
  tags: ["bookkeeping", "organization", "tax prep"]
};

export default function SimpleBookkeeping1099() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-10">
      <Helmet>
        <title>Simple Bookkeeping for 1099 Contractors | Free1099Calc</title>
        <meta
          name="description"
          content="A lightweight bookkeeping workflow for freelancers and small businesses—track income, expenses, and receipts without the overwhelm."
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Simple Bookkeeping for 1099 Contractors</h1>
      <p className="text-slate-700 mb-4">
        Keep it simple: one business checking account, a monthly spreadsheet (or basic software),
        and a consistent habit of categorizing income and expenses.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3">Core tips</h2>
      <ul className="list-disc pl-6 text-slate-700 space-y-2">
        <li>Separate business and personal spending.</li>
        <li>Save receipts and mileage logs as you go.</li>
        <li>Reconcile monthly so tax time is stress-free.</li>
      </ul>
    </main>
  );
}
